module.exports = __webpack_public_path__ + "img/block_1_tape.98c8a4ba.png";